module.exports = __webpack_public_path__ + "img/kab20-1.e94187d1.gif";